
export default (params = {}) => 
  Buffer.from(JSON.stringify(params)).toString('base64')